﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:HomeController
 * @description
 * # HomeController
 * Controller of the ntmApp
 */

/*jshint sub:true*/
angular.module('ntmApp')
  .filter('fromutc', ['$filter', '$locale', function ($filter, $locale) {

      return function (input, format) {
          if (!input) {
              return;
          }

          if (!angular.isDefined(format)) {
              format = $locale['DATETIME_FORMATS']['medium'];
          }
          return moment(input).format(format);
      };
  }]);